<template>
  <div>
    <ul v-loading="loading">
      <li v-for="(item, index) in newsList" :key="index" class="boxShadow">
        <div class="header">
          <img :src="item.userIcon" alt="">
          <div>
            <p class="textOver">{{ item.userName }}</p>
            <p class="textOver">{{ item.position }}</p>
          </div>
          <span>{{ item.createTime | DateFilter('yyyy-MM-dd hh:mm:ss') }}</span>
        </div>
        <div class="content clearfix" @click="goPostContent(item.id)">
          <img :src="item.thumb+'?imageView2/1/w/214/h/120'" alt="" class="contentImg">
          <div>
            <h3 class="textOver">{{ item.subject }}</h3>
            <p class="description ellipse2">{{ item.content }}</p>
            <p class="icon">
              <span>
                <i class="iconfont icon-dianzan" :class="{ 'isLikes': item.isLikes }" @click.stop="selectLike(item.id, index)"><font> {{ item.likes }} </font></i>
              </span>
              <span><i class="iconfont icon-pinglun"> <font> {{ item.comments }} </font></i></span>
              <!-- <span class="iconfont icon-fenxiang">&nbsp;&nbsp;分享</span> -->
              <span @click.stop="delPost(item.id, item.subject)" v-if="user.userId === item.userId"><i class="iconfont icon-shanchu"></i> 删除</span>
            </p>
          </div>
        </div>
      </li>
      <p v-if="newsList.length === 0" class="noContent boxShadow">帖子不存在或已被删除！</p>
    </ul>

    <div class='pages main-pagination' v-if="pageTotal > 6">
      <el-pagination :page-size="6" layout="prev, pager, next, jumper" background @current-change="handleCurrentChange" :total="pageTotal"></el-pagination>
    </div>

   <!-- 弹窗登录 -->
    <MaskLogin v-show='showLogin' @close='showLogin = false;'></MaskLogin>

    <!-- 消息弹框 -->
    <SubmitSuccess v-if='submitSuccessFlag' @close='submitSuccessFlag = false;' class='submit-success' :tipsMsg="tipsMsg"></SubmitSuccess>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      pageTotal: 0,
      newsList: [1],
      showLogin: false,
      submitSuccessFlag: false,
      pageIndex: 1,
      tipsMsg: '',
      loading: false,
    }
  },
  methods: {
    goPostContent(id) {
      this.$router.push({ path: `/navigator/bbs/postContent/${id}` });
    },
    getPostList() {  // 获取新闻列表
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      this.$http.post(`${this.URL_PREFIX}/app/get/bbs/post/list`, {
        parkId: this.currentParkId,
        currPage: this.pageIndex,
        pageRows: 6,
        subject: this.keyWords,
      }, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        this.loading = false;
        if (res.resCode === '10000') {
          this.pageTotal = res.resData.pageInfo ? res.resData.pageInfo.total : 0;
          this.newsList = res.resData.pageList ? res.resData.pageList : [];
        }
      });
    },
    selectLike(id, index) {  // 点赞
      if (!this.token) {
        this.showLogin = true;
        return;
      }
      this.$http.post(`${this.URL_PREFIX}/app/opt/bbs/likes/log`, {
        postId: id,
      }, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.newsList[index].isLikes = !this.newsList[index].isLikes;
          if (this.newsList[index].isLikes) {
            this.newsList[index].likes++;
          } else {
            this.newsList[index].likes--;
          }
        }
      });
    },
    handleCurrentChange(val) {  // 改变页数
      this.pageIndex = val;
      this.getPostList();
    },
    delPost(id, title) {
      if (!this.token) {
        this.showLogin = true;
        return;
      }
      this.$confirm(`确定删除帖子：${title}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post(`${this.URL_PREFIX}/app/delete/bbs/post`, {
          id: id,
        }, {
          headers: { token: this.token },
        }).then((response) => {
          const res = response.data;
          this.submitSuccessFlag = true;
          if (res.resCode === '10000') {
            this.tipsMsg = '删帖成功！';
            this.pageIndex = 1;
            this.getPostList();
          } else {
            this.tipsMsg = res.resDesc;
          }
        });
      }).catch(()=> {});;
    },
  },
  computed: {
    ...mapGetters(['currentParkId', 'token', 'user']),
  },
  mounted() {
    this.getPostList();
  },
  updated() {
    const imgs = this.$el.querySelectorAll('.contentImg') || [];
    imgs.forEach((val) => {
      val.style.width = '214px';
    });
  },
  props: {
    keyWords: {
      type: String,
      default: '',
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss';

li {
  height: 206px;
  margin-bottom: 20px;
  background-color: #fff;
  .header {
    padding: 12px 20px;
    background-color: #fbfbfb;
    height: 22px;
    display: flex;
    align-items: center;
    >div {
      flex: 1;
    }
    img {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      margin-right: 16px;
    }
    p {
      width: 560px;
      line-height: 16px;
      font-size: 10px;
      color: #666;
    }
    span {
      float: right;
      font-size: 10px;
      color: #666;
    }
  }
  .content {
    padding: 20px;
    cursor: pointer;
    // display: flex;
    .contentImg {
      width: 214px;
      border-radius: 4px;
      height: 120px;
      float: left;
    }
    >div {
      // flex: 1;
      float: left;
      width: 520px;
      margin-left: 20px;
    }
    h3 {
      width: 520px;
      font-size: 20px;
      color: #333;
      cursor: pointer;
    }
    .description {
      cursor: pointer;
      margin: 10px 0;
      font-size: 14px;
      color: #333;
      height: 50px;
      line-height: 25px;
      overflow: hidden;
    }
    .icon {
      display: flex;
      span {
        // flex: 1;
        display: inline-block;
        font-size: 16px;
        color: #666;
        padding-right: 40px;
        i {
          cursor: pointer;
          color: #999;
          font {
            color:#333;
          }
        }
        &:last-of-type {
          margin-right: 0;
        }
        &.icon-shanchu {
          cursor: pointer;
        }
        .isLikes {
          color: $color-main;
        }
        &.icon-pinglun {
          cursor: auto;
        }
      }
    }
  }
}
.noContent {
  height: 350px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
}

.pages{
  margin-top: 30px;
  text-align: center;
}
.submit-success {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/pages/navigator/bbs/microCommunity/PostList.vue